import { PublicClientApplication } from "@azure/msal-browser";
import type { Configuration } from "@azure/msal-browser";

const SPA_CLIENT_ID = process.env.REACT_APP_B2C_CLIENT_ID ?? "";

const msalConfig: Configuration = {
  auth: {
    clientId: SPA_CLIENT_ID,
    authority: "https://login.microsoftonline.com/common",
    redirectUri: `${window.location.origin}/auth-response`,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "memoryStorage",
    // Redirect flows need the interaction state (nonce/PKCE verifier) to survive
    // the full-page navigation, which in-memory cache can't do on its own — MSAL
    // falls back to a short-lived cookie for that state only; tokens still stay in memory.
    storeAuthStateInCookie: true,
  },
};

let instance: PublicClientApplication | null = null;

export function getIntuneMsalInstance(): PublicClientApplication {
  if (instance) return instance;

  if (!SPA_CLIENT_ID) {
    throw new Error("Missing REACT_APP_B2C_CLIENT_ID. Check env vars.");
  }

  instance = new PublicClientApplication(msalConfig);
  return instance;
}

// Since cacheLocation is "memoryStorage", dropping the reference discards its cache
// (accounts + tokens) entirely — the next getIntuneMsalInstance() call builds a fresh one.
export function resetIntuneMsalInstance(): void {
  instance = null;
}
